import { useEffect, useRef, useState } from "react";
import { KNIT_ALONG } from "@/content";
import { drawKnitmapCourses, loadKnitmap } from "./knitmap";

const CELL = 4;

type KnitmapCloseUpProps = {
  readonly from: number;
  readonly to: number;
  readonly alt: string;
};

// A few dozen courses of Suzanne's knitmap at four pixels a cell.
export const KnitmapCloseUp = ({ from, to, alt }: KnitmapCloseUpProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [isNear, setIsNear] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        setIsNear(true);
      },
      { rootMargin: "400px 0px" },
    );
    observer.observe(canvas);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isNear) return;
    let cancelled = false;

    loadKnitmap(KNIT_ALONG.knitmap)
      .then((knitmap) => {
        const context = canvasRef.current?.getContext("2d");
        if (!cancelled && context) drawKnitmapCourses(context, knitmap, { from, to, cell: CELL });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [isNear, from, to]);

  return (
    <canvas
      ref={canvasRef}
      role="img"
      aria-label={alt}
      width={KNIT_ALONG.needles * CELL}
      height={(to - from) * CELL}
      style={{ width: "100%", height: "auto", imageRendering: "pixelated" }}
    />
  );
};
